<template>
    <div>
        <div
            v-if="show"
            class="material_pop_mask"
            @touchstart.prevent="closePop"
            @mousedown.prevent="closePop"
            @click.prevent="closePop"
        ></div>
        <van-popup v-model="show" position="bottom" :style="{ height: '84%', zIndex: 2002 }" round :overlay="false">
            <div class="pop_main" @click="handlePopBlankClick">
            <div class="pop_header">
                <button type="button" @click="closePop">
                    <van-icon name="cross" />
                </button>
            </div>
            <div class="type_switch lv_flex" v-if="!replace">
                <div role="button" data-guide="material-flower-tab" :class="{ type_actived: params.classifyId1 === 1 }" @click.stop="chooseMaterialType(1)">花材</div>
                <div role="button" data-guide="material-container-tab" :class="{ type_actived: params.classifyId1 === 2 }" @click.stop="chooseMaterialType(2)">容器</div>
            </div>

            <div class="list-box">
                <div class="flower_type" v-if="params.classifyId1 === 1">
                    <div
                        v-for="item in flower.types"
                        :key="item.id"
                        :class="{ flower_type_actived: params.classifyId3 === item.id }"
                        @click="selectFlowerType(item)"
                    >
                        <span>{{ item.name }}</span>
                    </div>
                </div>
                <div class="flower_type" v-else>
                    <div
                        v-for="item in container.types"
                        :key="item.id"
                        :class="{ flower_type_actived: params.classifyId2 === item.id }"
                        @click="selectContainerType(item)"
                    >
                        <span>{{ item.name }}</span>
                    </div>
                </div>

                <div class="list">
                    <!-- 花 -->
                    <div v-if="params.classifyId1 === 1">
                        <template v-if="$store.state.routeParams.type === 'practice'">
                            <div class="lv_flex flower_other">
                                <div class="lv_flex_center" @click="flower.otherActived = 1">
                                    <i class="iconfont icon-yanse" v-if="activedColor.name === '颜色'" />
                                    <div v-else :style="{ background: activedColor.color }" class="active_color"></div>
                                    {{ activedColor.name }}
                                </div>
                                <div class="lv_flex_center" @click="flower.otherActived = 2">
                                    <i class="iconfont icon-kaifang" />
                                    {{ params.floweringStage ? params.floweringStage + "月" : "花季" }}
                                </div>
                                <div
                                    class="lv_flex_center"
                                    :class="{ actived_like: params.queryLikeMaterial }"
                                    @click="toggleLikeFilter"
                                >
                                    <i class="iconfont icon-xingxing" />
                                    常用
                                </div>
                                <!-- <div class="lv_flex_center" :class="{ actived_like: params.name }"
                                    @click="flower.otherActived = 4">
                                    <i class="iconfont icon-suofang" />搜索
                                </div> -->
                            </div>
                        </template>
                        <div v-if="flower.otherActived === 1" class="color_list">
                            <div
                                v-for="item in flower.colors"
                                :key="item.id"
                                :style="{ background: item.color }"
                                @click="
                                    params.colorClassifyId = item.id;
                                    reset();
                                "
                            ></div>
                        </div>

                        <div v-if="flower.otherActived === 2" class="month_list">
                            <div
                                @click="
                                    params.floweringStage = null;
                                    reset();
                                "
                            >
                                取消
                            </div>
                            <div
                                v-for="item in 12"
                                :key="item"
                                @click="
                                    params.floweringStage = item + '';
                                    reset();
                                "
                            >
                                {{ item }}月
                            </div>
                        </div>

                        <div class="mb_20">
                            <!-- <input type="text" v-model="params.name" placeholder="请输入搜索关键词">
                            <div class="lv_flex_center" @click="reset()">
                                <i class="iconfont icon-suofang" />搜索
                            </div> -->

                            <van-search v-model="params.name" placeholder="请输入搜索关键词" show-action background="#f7f7f7" @search="reset()">
                                <template #action>
                                    <div @click="reset()">搜索</div>
                                </template>
                            </van-search>
                        </div>
                    </div>
                    <!-- 器皿 -->
                    <div v-if="params.classifyId1 === 2">
                        <template v-if="$store.state.routeParams.type === 'practice'">
                            <div class="lv_flex flower_other">
                                <div
                                    class="lv_flex_center"
                                    :class="{ actived_like: params.queryLikeMaterial }"
                                    @click="toggleLikeFilter"
                                >
                                    <i class="iconfont icon-xingxing" />
                                    常用
                                </div>
                                <!-- <div class="lv_flex_center" :class="{ actived_like: params.name }"
                                    @click="container.otherActived = 4">
                                    <i class="iconfont icon-suofang" />搜索
                                </div> -->
                            </div>
                        </template>
                        <div class="mb_20">
                            <van-search v-model="params.name" placeholder="请输入搜索关键词" show-action background="#F4F6EE" @search="reset()">
                                <template #action>
                                    <div @click="reset()">搜索</div>
                                </template>
                            </van-search>
                        </div>
                    </div>

                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" class="van_list" @load="loadData">
                        <div v-for="(item, index) in list" :key="index" class="item">
                            <div class="flower_thumb">
                                <div
                                    class="flower"
                                    :data-guide="index === 0 ? firstMaterialGuideId : null"
                                    :style="{
                                        backgroundImage: `url(https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/${isHrss ? item.thumbnailImage : item.coverImage})`,
                                    }"
                                    @click="addItem(item.id || item.materialId, item)"
                                ></div>
                                <i class="iconfont icon-xingxing" :class="{ 'icon-xingxing1': item.likeMaterial }" @click.stop="changeLike(item)" v-if="$store.state.routeParams.type === 'practice'" />
                            </div>
                            <div class="name">{{ item.name }}</div>
                        </div>
                    </van-list>
                </div>
            </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    data() {
        return {
            replace: null,
            show: false,
            typeActived: 0,
            loading: false,
            finished: false,
            flower: {
                types: [],
                colors: [],
                months: [],
                otherActived: -1,
            },
            container: {
                types: [],
                otherActived: -1,
            },
            params: {
                classifyId1: 1,
                classifyId2: null,
                classifyId3: null,
                colorClassifyId: null,
                name: "",
                floweringStage: "",
                pageIndex: 0,
                pageSize: 12,
                queryLikeMaterial: false,
            },
            list: [],
            isHrss: false, // 是否是人事
        };
    },
    created() {
        this.getLabelList();
    },
    mounted() {
        this.$bus.$on("guide-select-material-type", this.chooseMaterialType);
        this.$bus.$on("guide-close-material", this.closePop);
        document.addEventListener("click", this.handleDocumentPopClose, true);
        document.addEventListener("touchstart", this.handleDocumentPopClose, true);
    },
    beforeDestroy() {
        this.$bus.$off("guide-select-material-type", this.chooseMaterialType);
        this.$bus.$off("guide-close-material", this.closePop);
        document.removeEventListener("click", this.handleDocumentPopClose, true);
        document.removeEventListener("touchstart", this.handleDocumentPopClose, true);
    },
    methods: {
        closePop() {
            this.show = false;
        },
        handleDocumentPopClose(event) {
            if (!this.show || !event || !event.target) {
                return;
            }
            const target = event.target;
            const ignoreSelector = ".pop_main, .material_catalog_tool, .practice_guide, .van-toast";
            if (target.closest && target.closest(ignoreSelector)) {
                return;
            }
            this.closePop();
        },
        handlePopBlankClick(event) {
            const target = event.target;
            if (!target || !this.show) {
                return;
            }
            const interactiveSelector = [
                ".pop_header button",
                ".type_switch [role='button']",
                ".flower_type > div",
                ".flower_other > div",
                ".color_list > div",
                ".month_list > div",
                ".van-search",
                ".item",
                ".van-list__loading",
                ".van-list__finished-text",
            ].join(",");
            if (target.closest && target.closest(interactiveSelector)) {
                return;
            }
            const blankSelector = ".pop_main,.list-box,.list,.van_list,.mb_20";
            if (target.closest && target.closest(blankSelector)) {
                this.closePop();
            }
        },
        async changeLike(item) {
            if (item.likeMaterial) {
                await this.$ajax.get("/material/deleteLikeMaterial", {
                    params: { materialId: item.id },
                });
            } else {
                await this.$ajax.post("/material/saveLikeMaterial", {
                    materialId: item.id,
                });
            }
            item.likeMaterial = !item.likeMaterial;
            Toast(item.likeMaterial ? "已放入您的常用栏目中" : "已从常用栏目移除");
        },
        toggleLikeFilter() {
            this.params.queryLikeMaterial = !this.params.queryLikeMaterial;
            Toast(this.params.queryLikeMaterial ? "已打开常用" : "取消选中常用");
            this.reset();
        },
        async open(replace, type = null) {
            this.params.classifyId1 = (replace && replace.classifyId1) || 1;
            this.replace = replace || null;

            if (type) {
                this.params.classifyId1 = type;
            }

            if (this.list.length) {
                this.typeReset();
            }
            if ([61, 62, 63].includes(this.params.classifyId1)) {
                this.isHrss = true;
            } else {
                this.isHrss = false;
            }
            await this.getLabelList();
            this.show = true;
        },
        chooseMaterialType(type) {
            if (this.params.classifyId1 === type) {
                this.$bus.$emit("guide-material-tab-change", type);
                return;
            }
            this.params.classifyId1 = type;
            this.typeReset();
            this.$bus.$emit("guide-material-tab-change", type);
        },
        addItem(id, data) {
            if (this.$store.state.routeParams.mode === "examine") {
                return;
            }
            if (this.isHrss) {
                let https = "https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/";
                if (this.params.classifyId1 == 61) {
                    this.$bus.$emit("changeMusic", {
                        data: data,
                        url: https + data.audioUrl,
                    });
                }
                if (this.params.classifyId1 == 62) {
                    this.$bus.$emit("changeTable", {
                        data: data,
                        url: data.thumbnailImage,
                    });
                }
                if (this.params.classifyId1 == 63) {
                    this.$bus.$emit("changeBg", {
                        data: data,
                        url: https + data.thumbnailImage,
                    });
                }
                this.show = false;
            } else {
                if (this.replace && this.replace.id) {
                    this.$bus.$emit("replace", {
                        id: this.replace.id,
                        resourceId: id,
                    });
                    this.show = false;
                } else {
                    this.$bus.$emit("guide-material-picked", {
                        type: this.params.classifyId1,
                        resourceId: id,
                    });
                    this.$bus.$emit("addItem", {
                        resourceId: id,
                        materialClassifyId1: this.params.classifyId1,
                    });
                }
            }
        },
        typeReset() {
            this.params.classifyId2 = null;
            this.params.classifyId3 = null;
            this.params.colorClassifyId = null;
            this.params.name = null;
            this.params.queryLikeMaterial = false;
            this.reset();
        },
        selectFlowerType(item) {
            this.params.classifyId3 = item.id;
            this.reset();
        },
        selectContainerType(item) {
            this.params.classifyId2 = item.id;
            this.reset();
        },
        reset() {
            this.params.pageIndex = 1;
            this.params.pageSize = 12;
            this.list = [];
            this.finished = false;
            this.loading = true;
            this.flower.otherActived = -1;
            this.container.otherActived = -1;
            this.getList();
        },
        loadData() {
            this.params.pageIndex++;
            this.getList();
        },
        getLabelList() {
            return this.$ajax.post("admin/classifyManage/queryAll").then(res => {
                const resData = res.data;
                this.flower.types = [
                    {
                        name: "全部",
                        id: null,
                        parentId: null,
                    },
                    ...resData[0].child[0].child,
                    ...resData[0].child[1].child,
                ];
                this.flower.colors = [
                    {
                        name: "无",
                        id: null,
                        color: "url(https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/static/masaike.png)",
                    },
                    ...resData[3].child,
                ];
                const containerClassify = resData.find(item => {
                    return item.id === 2;
                }) || resData[1] || {};
                this.container.types = [
                    {
                        name: "全部",
                        id: null,
                        parentId: null,
                    },
                    ...(containerClassify.child || []),
                ];
            });
        },
        normalizeParams(params) {
            const nextParams = { ...params };
            if (nextParams.classifyId1 === 1) {
                if (nextParams.classifyId3) {
                    const flowerType = this.flower.types.find(item => {
                        return item.id === nextParams.classifyId3;
                    });
                    nextParams.classifyId2 = flowerType ? flowerType.parentId : null;
                } else {
                    nextParams.classifyId2 = null;
                }
            }
            return nextParams;
        },
        getList() {
            if (this.$store.state.routeParams.type !== "practice") {
                const list = this.$store.state.limitMaterials[this.params.classifyId1 - 1].useMaterials;
                if (list.length) {
                    // 有限制制材料
                    this.list = list;
                    this.loading = false;
                    return;
                }
            }

            this.params = this.normalizeParams(this.params);
            this.$ajax.post(this.isHrss ? "/material/hrss/queryFlowerList" : "/material/queryFlowerList", this.params).then(res => {
                this.list = this.list.concat(res.list);
                this.loading = false;
                // 数据全部加载完成
                if (this.list.length >= res.total) {
                    this.finished = true;
                }
            });
        },
    },
    computed: {
        firstMaterialGuideId() {
            return this.params.classifyId1 === 2 ? "container-first-card" : "flower-first-card";
        },
        activedColor() {
            return !this.params.colorClassifyId
                ? {
                      name: "颜色",
                  }
                : this.flower.colors.find(item => {
                      return item.id === this.params.colorClassifyId;
                  });
        },
    },
};
</script>

<style lang="scss" scoped>
.material_pop_mask {
    position: fixed;
    inset: 0;
    z-index: 2001;
    background: rgba(0, 0, 0, 0.34);
}

.pop_main {
    background: #f6f7f2;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    z-index: 99;

    .flower_type {
        width: rem(146);
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        padding-top: rem(8);
        background: #f0f3ea;

        > div {
            min-height: rem(78);
            flex-shrink: 0;
            padding: rem(8) rem(10);
            box-sizing: border-box;

            > span {
                font-size: rem(24);
                line-height: rem(33);
                padding: rem(10) rem(18);
                width: 100%;
                border-radius: rem(18);
                display: inline-block;
                box-sizing: border-box;
                color: #5f675c;
            }
        }

        .flower_type_actived {
            > span {
                background: #e8efd5;
                color: #8bb229;
            }
        }
    }

    .flower_other {
        margin-bottom: rem(14);
        padding-right: rem(20);

        > div {
            min-width: rem(150);
            padding: 0 rem(18);
            text-align: center;
            background: #fff;
            border-radius: rem(18);
            border: 1px solid #e1e8d8;
            height: rem(56);
            box-sizing: border-box;
            color: #50594c;
            font-size: rem(23);

            + div {
                margin-left: rem(12);
            }
        }

        i {
            margin-right: 2px;
        }
    }

    .color_list {
        > div {
            width: rem(38);
            height: rem(38);
            border-radius: rem(9);
            display: inline-block;
            margin-left: rem(26);
            margin-bottom: rem(25);

            &:nth-child(11n + 1) {
                margin-left: 0;
            }
        }
    }

    .active_color {
        width: rem(35);
        height: rem(35);
        border-radius: rem(9);
        margin-right: 5px;
    }

    .month_list {
        padding-right: rem(20);

        > div {
            width: rem(85);
            line-height: rem(56);
            text-align: center;
            display: inline-block;
            border-radius: rem(14);
            border: 1px solid #dcdfe6;
            margin-left: rem(10);
            margin-bottom: rem(25);

            &:nth-child(7n + 1) {
                margin-left: 0;
            }
        }
    }

    .actived_like {
        color: #df8c07;
        background: #fff6dc;
        border-color: #efb43e;
        box-shadow: inset 0 0 0 1px rgba(239, 180, 62, 0.22);
        font-weight: bold;

        i {
            color: #df8c07;
        }
    }
}

.list-box {
    position: relative;
    flex: 1;
    // height: rem(320);
    overflow: hidden;
    margin-top: rem(14);
    display: flex;
    justify-content: flex-start;

    .item {
        width: 100%;
        margin: 0;
        display: block;
    }

    .flower_thumb {
        position: relative;
        width: 100%;
        height: 0;
        padding-top: 100%;
        margin-bottom: rem(8);
        display: block;

        i {
            position: absolute;
            right: rem(7);
            bottom: rem(7);
            width: rem(34);
            height: rem(34);
            line-height: rem(34);
            text-align: center;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.94);
            box-shadow: 0 rem(3) rem(10) rgba(34, 52, 17, 0.16);
            z-index: 2;
        }
    }

    .flower {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border-radius: rem(14);
        border: 1px solid #e0e4d8;
        background-color: #fff;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        box-shadow: 0 rem(6) rem(16) rgba(36, 45, 31, 0.08);
    }

    .name {
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #444d41;
        font-size: rem(20);
    }
}

.van_list {
    height: 100%;
    overflow-y: scroll;
    flex: 1;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-rows: max-content;
    column-gap: rem(10);
    row-gap: rem(18);
    align-content: flex-start;
    justify-content: stretch;
    background: #fff;
    padding: rem(16) rem(12) rem(20);
    box-sizing: border-box;
}

.van_list ::v-deep .van-list__finished-text,
.van_list ::v-deep .van-list__loading {
    grid-column: 1 / -1;
}

.list {
    height: 100%;
    flex: 1;

    display: flex;
    flex-direction: column;
}

.mb_20 {
    margin-bottom: rem(20);

    padding-right: rem(20);
}

.pop_header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: #fff;
    padding: rem(12) rem(18) rem(4);
    border-bottom: 1px solid #edf0e4;

    button {
        width: rem(50);
        height: rem(50);
        flex-shrink: 0;
        border: 0;
        border-radius: 50%;
        background: #f3f5ef;
        color: #687163;
        font-size: rem(28);
    }
}

.type_switch {
    background: #fff;
    padding: rem(16) rem(24);
    border-bottom: 1px solid #edf0e4;

    > div {
        flex: 1;
        height: rem(60);
        line-height: rem(60);
        text-align: center;
        border: 1px solid #dbe3d1;
        border-radius: rem(18);
        background: #fff;
        color: #666;
        font-size: rem(25);
        box-sizing: border-box;

        + div {
            margin-left: rem(12);
        }
    }

    .type_actived {
        color: #6e9f21;
        background: #e8efd5;
        border-color: #8bb229;
        font-weight: bold;
    }
}

::v-deep .van-search {
    padding: unset;
}

::v-deep .van-search__content {
    background-color: #fff !important;
}

::v-deep .van-search__action {
    background: #8bb229;
    border-radius: rem(6);
    padding: 0 rem(30);
    color: #fff;
}

::v-deep .van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
    font-size: 24px;
}
</style>
